/**
 * Representa os tipos estratégicos de produtos dentro do PLM (Product Lifecycle Management)
 */
export enum EnumTipoEstrategicoPLM {
  Inovacao = 1,
  ComplementoLinha = 2,
  Extensao = 3,
  Reposicionamento = 4,
}

export const TIPO_ESTRATEGICO_PLM_LABELS: Record<EnumTipoEstrategicoPLM, string> = {
  [EnumTipoEstrategicoPLM.Inovacao]: 'Inovação',
  [EnumTipoEstrategicoPLM.ComplementoLinha]: 'Complemento de Linha',
  [EnumTipoEstrategicoPLM.Extensao]: 'Extensão',
  [EnumTipoEstrategicoPLM.Reposicionamento]: 'Reposicionamento',
};

/** Descrições para cada tipo estratégico do PLM */
export const TIPO_ESTRATEGICO_PLM_DESCRIPTIONS: Record<EnumTipoEstrategicoPLM, string> = {
  [EnumTipoEstrategicoPLM.Inovacao]: 'Quando o produto é considerado uma inovação',
  [EnumTipoEstrategicoPLM.ComplementoLinha]: 'Quando o produto é considerado um complemento de linha',
  [EnumTipoEstrategicoPLM.Extensao]: 'Quando o produto é uma extensão de uma linha existente',
  [EnumTipoEstrategicoPLM.Reposicionamento]: 'Quando o produto é um reposicionamento de um produto existente',
};
